import {
  Component,
  OnInit,
  Inject,
  OnDestroy,
  AfterViewInit,
} from '@angular/core';
import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from '@azure/msal-angular';
import {
  AuthenticationResult,
  InteractionStatus,
  PopupRequest,
  RedirectRequest,
  EventMessage,
  EventType,
  AccountInfo,
} from '@azure/msal-browser';
import { Subject, of } from 'rxjs';
import { filter, switchMap, takeUntil } from 'rxjs/operators';
import { UserService } from './service/user.service';
import { Router } from '@angular/router';
import { AuthGuardService } from './service/auth-guard.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  public activeAccount: AccountInfo | undefined;
  title = 'NWMO Calculator';
  public impersonate: boolean = false;
  private readonly _destroying$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    public route: Router,
    public userService: UserService,
    private authGuardService: AuthGuardService
  ) {}

  ngOnInit() {
    this.userService
      .getAssumptions()
      .pipe(takeUntil(this._destroying$))
      .subscribe();
    this.userService
      .getAllDataUploadStatus()
      .pipe(takeUntil(this._destroying$))
      .subscribe();

    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        switchMap(() => {
          if (this.authService.instance.getAllAccounts().length === 0) {
            if (this.msalGuardConfig.authRequest) {
              this.authService.loginRedirect();
            }
            this.route.navigate(['/invalid']);
            return of(null); 
          } else {
            const accounts = this.authService.instance.getAllAccounts();
            this.authService.instance.setActiveAccount(accounts[0]);
            this.activeAccount = accounts[0];
            // If there is an active account, emit an observable with the username
            this.userService.setCurrentUser(this.activeAccount.username);
            this.userService.currentUser$.subscribe((user) =>{
              if(!this.activeAccount?.username || (user && user.IsLocked)) {
                this.route.navigate(['/invalid']);
              }
            });
            return this.userService.currentUser$;
          }
        }),
        takeUntil(this._destroying$)
      )
      .subscribe();

    this.userService.impersonate$.subscribe((impersonate: boolean) => {
      this.impersonate = impersonate;
      if (this.userService.getCurrentUser().IsAdmin && !impersonate) {
        this.route.navigate(['/admin']);
      }
    });
  }
  
  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
